import type { RowVariantDefinition } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'
import { defineRowVariantRegistry } from '@/deskUiSkeletons/rowTemplates/RowVariantRegistry'
import { sharedChatAnswerVariant } from '@/msgComponents/rowVariants/Chat/Chat'
import { productRowVariantForPath, productRowVariantsForPath } from '../../../productDisplayCatalog'
import { ForumPhpbbTemplate } from './variants/ForumPhpbb'

const forumPhpbbVariant = {
  ...productRowVariantForPath('forum', 2),
  Template: ForumPhpbbTemplate,
} as const satisfies RowVariantDefinition

const productRows = productRowVariantsForPath('forum')

export const rowVariantRegistry = defineRowVariantRegistry({
  answers: {
    variants: [forumPhpbbVariant, sharedChatAnswerVariant],
    fallback: productRows.answers.fallback,
  },
  submsges: {
    variants: [forumPhpbbVariant],
    fallback: productRows.submsges.fallback,
  },
})
